interface ContentBodyListProps {
  header?: string;
  title: string;
  itemList?: string[] | undefined;
  info?: string;
}

export const ContentBodyList: React.FC<ContentBodyListProps> = ({
  header,
  title,
  itemList,
  info,
}) => {
  return (
    <>
    <h3 className="text-h3 text-text-heading">{header}</h3>
      <p>{title}</p>
      {itemList !== undefined && itemList.length > 0 ? (
        <ul className="list-disc">
          {itemList.map((item, index) => (
            <li key={`${item}_${index}`} className="ml-6">
              {item}
            </li>
          ))}
        </ul>
      ) : null}
      <p>{info}</p>

    </>
  );
};
//condition ? <ConditionalComponent /> : null;
